export default function getPercentageFromBooleanArray (arr: boolean[] | undefined): number {
  if (!arr) {
    return 0;
  }

  const truthy = arr.filter(x => !!x).length;

  return 0 === arr.length ? 0 : Math.round(((100 * truthy) / arr.length));
}
